<app-breadcrumb-mkt [title]="title" [routeBase]="route"/>

<table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
  <!-- Columna: Número -->
  <ng-container matColumnDef="position">
    <th mat-header-cell *matHeaderCellDef > # </th>
    <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
  </ng-container>

  <!-- Columna: Nombre Descuento -->
  <ng-container matColumnDef="nombre_descuento">
    <th mat-header-cell  *matHeaderCellDef > Nombre Descuento </th>
    <td mat-cell *matCellDef="let element">
      {{ convertirPrimeraLetraMayuscula(element.nombre_descuento) }}
    </td>
  </ng-container>

  <!-- Columna: Valor -->
  <ng-container matColumnDef="valor_desc">
    <th mat-header-cell *matHeaderCellDef > Valor </th>
    <td mat-cell *matCellDef="let element"> ${{ element.valor_desc }} </td>
  </ng-container>

  <!-- Columna: Tipo -->
  <ng-container matColumnDef="tipo_desc">
    <th mat-header-cell *matHeaderCellDef> Tipo </th>
    <td mat-cell *matCellDef="let element">
      {{ convertirPrimeraLetraMayuscula(element.tipo_desc) }}
    </td>
  </ng-container>

  <!-- Columna: Estado -->
  <ng-container matColumnDef="estado">
    <th mat-header-cell *matHeaderCellDef> Estado </th>
    <td mat-cell *matCellDef="let element"> {{ element.estado }} </td>
  </ng-container>

  <!-- Columna: Acciones -->
  <ng-container matColumnDef="acciones">
    <th mat-header-cell *matHeaderCellDef> Acciones </th>
    <td mat-cell *matCellDef="let element">
      <button mat-button color="primary" (click)="getAllDataPromotion(element.codDescuentos)"
              data-bs-toggle="modal" data-bs-target="#formAddPromotion">
        <i class="bi bi-arrow-down-square-fill"></i> Importar
      </button>
    </td>
  </ng-container>

  <!-- Encabezado y cuerpo de la tabla -->
  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>


</table>



<div #importPromocion class="modal fade" id="formAddPromotion" data-bs-backdrop="static"  tabindex="-1"
     aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="staticBackdropLabel">Importar Promoción</h1>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" >
        <div class="col-md-7 col-lg-12">
          <form class="needs-validation" [formGroup]="formPromocion" novalidate (ngSubmit)="onSubmit()">
            <div class="row g-3">
              <div class="col-sm-12">
                <label for="codCategoria">Escoge la categoría <span class="text-body-secondary">(Esto definirá en que especialidad se muestra)</span></label>
                <select class="form-control" formControlName="_id"  name="categoria" id="codCategoria">
                  <option disabled selected value="">Escoge una categoría</option>
                  <option *ngFor="let item of categorias" [value]="item._id">
                    {{ item.categoria }}
                  </option>
                </select>
                <div style="color:red;" *ngIf="formPromocion.get('_id')?.errors?.['required']">La categoría es obligatoria</div>
              </div>

              <div class="col-sm-6">
                <label for="firstName" class="form-label">Nombre Visible</label>
                <input [value]="name" formControlName="nombre" type="text" class="form-control" id="firstName" placeholder=""
                       required/>
                <div style="color:red;" *ngIf="formPromocion.get('nombre')?.errors?.['required']">El nombre es obligatorio</div>

              </div>

              <div class="col-sm-6">
                <label for="lastName" class="form-label">Tipo Promoción</label>
                <input [value]="tipoPromocion" formControlName="tipoPromocion" type="text" class="form-control" id="lastName" placeholder=""
                       required>
                <div style="color:red;" *ngIf="formPromocion.get('tipoPromocion')?.errors?.['required']">El tipo es obligatorio</div>

              </div>

              <div class="col-12">
                <label for="serviciosPromocion" class="form-label">Servicios de la promoción<span class="text-body-secondary">(Son los items de la promoción)</span></label>
                <textarea [value]="servicios" formControlName="servicios" class="form-control" id="serviciosPromocion"
                          placeholder="Descripción de la promoción"></textarea>
                <div style="color:red;" *ngIf="formPromocion.get('servicios')?.errors?.['required']">Los servicios son obligatorios</div>

              </div>

              <div class="col-12">
                <label for="descriptionPromocion" class="form-label">Descripción de la promoción<span class="text-body-secondary">(Añadir una pequeña descripcion sobre la promoción)</span></label>
                <textarea [value]="descripcion" formControlName="descripcion" class="form-control" id="descriptionPromocion"
                          placeholder="Descripción de la promoción"></textarea>
                <div style="color:red;" *ngIf="formPromocion.get('descripcion')?.errors?.['required']">La descripcion es obligatoria</div>

              </div>

              <div class="col-12">
                <label for="disclaimer" class="form-label">Disclaimer <span class="text-body-secondary">(Este texto siempre se verá rojo)</span></label>
                <textarea formControlName="disclaimer" class="form-control" id="disclaimer"
                          placeholder="¿Algo más que agregar?" ></textarea>
                <div style="color:red;" *ngIf="formPromocion.get('disclaimer')?.errors?.['required']">Es disclaimer es obligatorio</div>

              </div>

              <div class="col-md-5">
                <label for="statusPromotion" class="form-label">Estado Promoción</label>
                <select formControlName="statusPromocion" class="form-select" id="statusPromotion" required>
                  <option value="" disabled>Escoge...</option>
                  <option selected [value]="true">Activo</option>
                  <option [value]="false">Inactiva</option>
                </select>
                <div style="color:red;" *ngIf="formPromocion.get('statusPromocion')?.errors?.['required']">Es status es obligatorio</div>

              </div>

              <div class="col-md-4">
                <label for="date" class="form-label">Fecha Caducidad</label>
                <input formControlName="fechaExpiracion" type="date" id="date" class="form-control" value="12-12-2050">
                <div style="color:red;" *ngIf="formPromocion.get('fechaExpiracion')?.errors?.['required']">La fecha es obligatoria</div>

              </div>

              <div class="col-md-3">
                <label for="valorPromocion" class="form-label">Valor</label>
                <input type="text" class="form-control" id="valorPromocion" placeholder="" [disabled]="valuePromotion"
                       [value]="'$' + valuePromotion" required>
                <div style="color:red;" *ngIf="formPromocion.get('valorPromocion')?.errors?.['required']">El valor es obligatorio</div>

              </div>

              <hr class="my-4">

              <h4 class="mb-3">Multimedia</h4>

              <div class="my-3">
                <div class="form-check">
                  <label class="form-check-label" for="file">Imagen <span class="text-body-secondary">(Se recomienda imagen en formato 4x4 para mejorar su visibilidad y en formato .webp)</span></label>
                  <input #inputImage  type="file" id="file" class="form-control" (change)="capturarArchivo($event)" accept="image/*">

                </div>

                <div class="input-group image">
                  <img width="100%" [src]="preview" alt="">
                </div>
              </div>

              <div class="row gy-3"></div>

              <hr class="my-4">


              <div class="w-100 align-baseline" >
                <button (click)="sendAllData()" class=" btn btn-primary w-100" [disabled]="isLoading">
            <span class="text" *ngIf="!isLoading">
            Importar Promoción
            </span>
                  <div *ngIf="isLoading" class="spinner-border text-light " role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</div>
<app-notifications/>
